'use client';

import { BlurImage } from '@mcdougald/ui/src';
import NumberFlow, { continuous } from '@number-flow/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import ImageZoom from '@/components/image-zoom';
import Link from '@/components/link';
import { useFormattedDate } from '@/hooks/use-format-date';
import { usePostContext } from '@/store/context/post';
import { useTRPC } from '@/trpc/client';

const Header = () => {
  const { date, title, slug } = usePostContext();
  const formattedDate = useFormattedDate(date);

  const trpc = useTRPC();
  const queryClient = useQueryClient();

  // const t = useTranslations();

  const incrementMutation = useMutation(
    trpc.views.increment.mutationOptions({
      onSettled: () =>
        queryClient.invalidateQueries({
          queryKey: trpc.views.get.queryKey({ slug }),
        }),
    }),
  );

  const viewsCountQuery = useQuery(
    trpc.views.get.queryOptions({ slug: String(slug) }),
  );
  const commentsCountQuery = useQuery(
    trpc.comments.getTotalCommentsCount.queryOptions({ slug: String(slug) }),
  );

  const incremented = useRef(false);

  useEffect(() => {
    if (!incremented.current) {
      incrementMutation.mutate({ slug: String(slug) });
      incremented.current = true;
    }
  }, [incrementMutation, slug]);

  return (
    <div className="space-y-16 py-16 mx-auto">
      <div className="space-y-16 sm:px-8">
        <h1 className="bg-linear-to-b from-black via-black/90 to-black/70 to-90% bg-clip-text text-center text-4xl font-bold text-transparent md:text-5xl md:leading-[64px] dark:from-white dark:via-white/90 dark:to-white/70">
          {title}
        </h1>
        <div className="grid grid-cols-2 text-sm max-md:gap-4 md:grid-cols-4">
          <div className="space-y-1 md:mx-auto">
            <div className="text-muted-foreground">{'Written by'}</div>
            <Link
              href="https://github.com/mcdougald"
              className="flex items-center gap-2"
            >
              {/*<BlurImage*/}
              {/*  src="/images/blogs/Notes.png"*/}
              {/*  className="rounded-full"*/}
              {/*  width={24}*/}
              {/*  height={24}*/}
              {/*  alt="TM"*/}
              {/*/>*/}
              Trevor McDougald
            </Link>
          </div>
          <div className="space-y-1 md:mx-auto">
            <div className="text-muted-foreground">{'Published on'}</div>
            <div>{formattedDate}</div>
          </div>
          <div className="space-y-1 md:mx-auto">
            <div className="text-muted-foreground">{'Views'}</div>
            {viewsCountQuery.status === 'pending' ? '--' : null}
            {viewsCountQuery.status === 'error' ? 'Error' : null}
            {viewsCountQuery.status === 'success' ? (
              <NumberFlow
                willChange
                plugins={[continuous]}
                value={viewsCountQuery.data.views}
                data-testid="view-count"
              />
            ) : null}
          </div>
          <div className="space-y-1 md:mx-auto">
            <div className="text-muted-foreground">{'Comments'}</div>
            {commentsCountQuery.status === 'pending' ? '--' : null}
            {commentsCountQuery.status === 'error' ? 'Error' : null}
            {commentsCountQuery.status === 'success' ? (
              <NumberFlow
                willChange
                plugins={[continuous]}
                value={commentsCountQuery.data.comments}
                data-testid="comment-count"
              />
            ) : null}
          </div>
        </div>
      </div>
      <ImageZoom
        zoomImg={{
          // src: `/images/blogs/${slug}/cover.png`,
          src: `/images/blogs/Notes.png`,
          alt: title,
        }}
      >
        <BlurImage
          // src={`/images/blog/${slug}/cover.png`}
          src={'/images/blogs/Notes.png'}
          className="rounded-lg justify-self-center"
          width={600}
          height={300}
          lazy={false}
          alt={title}
        />
      </ImageZoom>
    </div>
  );
};

export default Header;
